// Image requested sizes are here - src/constants/sponsoredAdsBannerAds.ts
export const imageClasses = 'h-auto aspect-[3/1] sm:aspect-[8/1] max-h-[160px] sm:max-h-[180px]';

export const containerClasses = 'm-auto w-full flex justify-center';

export const linkClasses = 'relative';

export const sponsoredAfterClasses = "after:absolute after:right-2 after:mt-1 after:text-xs after:text-tertiary after:content-['Sponsored']";
